export default __webpack_public_path__ + "static/char-58-anr-396691434d4665839c05bbf5d1cbaf83.gif";